import React from "react";
import { formatLastFour, generateLoanDescription } from "../misc/messaging-utils";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthRestartButton } from "../misc/restart-button.component";
import { ReviewDisplayField } from "../misc/review-display-field.component";
import { summarySubtitle } from "../misc/summary-subtitle.component";

export const AuthPaymentInternalTransferSummary = (props) => {
  const subtitle = summarySubtitle(
    props.confirmationEmail,
    props.isPayoff,
    props.isPrincipalOnly,
    props.selectedLoan.NextDueDate
  );

  return (
    <AuthPaymentContainer
      title={props.isPayoff ? "Payoff Confirmation" : "Payment Summary"}
      subtitle={subtitle}
    >
      <div className="bold f20 text-centered">
        {`${generateLoanDescription(props.selectedLoan, true)}`}
      </div>
      <div className="my-4 divider"></div>
      <div>
        <ReviewDisplayField title={"Payment Applied Date"} value={props.paymentAppliedDate} />
        <ReviewDisplayField
          title={"Payment Account"}
          value={`${props.paymentAccount.AccountType} (${props.paymentAccount.AccountLastFour})`}
          valueClassNames={"minwidth-fit"}
          titleColumnSize={"col-md-6"}
          valueColumnSize={"col-md-6"}
        />
        <ReviewDisplayField title={"Payment Amount"} value={props.paymentAmount} />
      </div>
      <AuthRestartButton backToLoans={props.backToLoans} bgColor={"#00558c"} />
    </AuthPaymentContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/summary/auth-payment-internal-transfer-summary.component.js